<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="10">
                统计项目类型：
                <el-radio-group v-model="checkedClass" size="mini" @input="renderCharts">
                    <el-radio-button label="W">吴中区</el-radio-button>
                    <el-radio-button label="X">相城区</el-radio-button>
                    <el-radio-button label="G">高新区</el-radio-button>
                    <el-radio-button label="T">太湖区</el-radio-button>
                    <el-radio-button label="Y">园区</el-radio-button>
                </el-radio-group>
            </el-col>
            <el-col :span="14">
                <el-alert type="warning" :closable="false" show-icon title="统计数据为最近5年数据"></el-alert>
            </el-col>
        </el-row>
        <el-divider><i class="el-icon-search"></i></el-divider>
        <div id="registerDiv" class="registerDiv" v-loading="divLoading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 0.8)">

        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            checkedClass:"W",
            divLoading:false,
            myChart:null,
        }
    },
    mounted(){
        this.renderCharts()
    },
    methods:{
        async renderCharts(){
            this.divLoading=true;
            var allData
            const{data:res}=await this.$http.post('os/registerStat',{data:this.checkedClass}).catch(err => err)
            if(res){
                allData=res
            }else{
                this.divLoading=false
                return;
            }
            this.divLoading=false
            // 初始化echarts实例
            if (this.myChart != null && this.myChart != "" && this.myChart != undefined) {
                this.myChart.dispose();//销毁
            }
            this.myChart = this.$echarts.init(document.getElementById("registerDiv"))
            //参数
            var rotate = 90;
            var align = 'left';
            var verticalAlign = 'middle';
            var position = 'insideBottom';
            var distance = 15;
            const labelOption = {
                show: true,
                position: position,
                distance: distance,
                align: align,
                verticalAlign:verticalAlign,
                rotate: rotate,
                formatter: '{c}',
                fontSize: 16,
                rich: {
                    name: {}
                }
            };
            // 绘制图表
            this.myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                grid: {
                    left: '20%'
                },
                legend: {
                    data: ['项目总数', '项目总额', '项目平均额']
                },
                toolbox: {
                    show: true,
                    orient: 'horizontal',

                    showTitle: true,
                    feature: {
                        mark: { show: true },
                        dataView: { show: true, readOnly: false },
                        magicType: { show: true, type: ['line', 'bar', 'stack'] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                xAxis: [
                    {
                        type: 'category',
                        axisTick: { show: true },
                        //年份数据
                        data: allData.years
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '总数(个)',
                        position: 'left',
                        offset: 80,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'blue'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,//全显示
                            rotate: -30//倾斜-30
                        }
                    },
                    {
                        type: 'value',
                        name: '总额(元)',
                        position: 'right',

                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'green'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,//全显示
                            rotate: -30//倾斜-30
                        }
                    },
                    {
                        type: 'value',
                        name: '平均额(元)',
                        position: 'left',

                        axisLine: {
                            show: true,
                            lineStyle: {
                                color: 'orange'
                            }
                        },
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,//全显示
                            rotate: -30//倾斜-30
                        }
                    },

                ],
                series: [
                    {
                        name: '项目总数',
                        type: 'bar',
                        barGap: 0,
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        yAxisIndex: 0,
                        //项目总数数据
                        data: allData.counts
                    },
                    {
                        name: '项目总额',
                        type: 'bar',
                        barGap: 0,
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        yAxisIndex: 1,
                        //项目总额数据
                        data: allData.allMyCounts
                    },
                    {
                        name: '项目平均额',
                        type: 'bar',
                        barGap: 0,
                        label: labelOption,
                        emphasis: {
                            focus: 'series'
                        },
                        yAxisIndex: 2,
                        //项目平均额数据
                        data: allData.avgMyCounts
                    }
                ]
            })
        },

    },
}
</script>
<style scope>
.registerDiv {
    width:1200px;
    height: 600px;
    overflow: hidden;
}
</style>